import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        addFilter: (state, {payload}) => payload,
        toggleFilter: (state, action) => {
            const { index, key } = action.payload;
            state[index][key] = !state[index][key];
        },
        resetFilters: () => [],
    }
})



export const { addFilter, toggleFilter,resetFilters } = filtersSlice.actions

export default filtersSlice.reducer